import * as DomBuilder from "./dom-builder.js";

/**
 *
 * @version 2026-09-03
 * @author Patrik Harag
 */

export function formatValue(val) {
    return Number(Number(val).toFixed(2)).toLocaleString('cs', {
        minimumFractionDigits: 2
    });
}

export function parseHexColor(hexColor) {
    const hexRegex = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i;
    const result = hexRegex.exec(hexColor);

    if (result) {
        const r = parseInt(result[1], 16);
        const g = parseInt(result[2], 16);
        const b = parseInt(result[3], 16);
        return [r, g, b];
    } else {
        return null;
    }
}

export function createValue(val, title = null) {
    let formatted = '' + formatValue(val);
    let parts = formatted.split(',');
    let nodes = [
        DomBuilder.span(parts[0], { class: 'value-integer-part' }),
        DomBuilder.span(',' + parts[1], { class: 'value-floating-part' })
    ];
    if (title) {
        return [DomBuilder.span(nodes, { class: 'value-with-fx', title: title })];
    }
    return nodes;
}

/**
 * @param transaction {Transaction}
 * @return {string|null}
 */
export function formatFxTooltip(transaction) {
    if (!transaction.isConverted()) {
        return null;
    }
    let quote = transaction.getFxQuote();
    let original = formatValue(transaction.getNativeValue()) + ' ' + transaction.getNativeCurrency();
    let rate = Number(quote.rate).toLocaleString('cs', {
        maximumFractionDigits: 6
    });
    let source = quote.period ? (quote.source + ' ' + quote.period) : quote.source;
    return original + ' × ' + rate + ' (' + source + ')';
}

/**
 * @param transactions {Transaction[]}
 * @return {string|null}
 */
export function formatFxAggregateTooltip(transactions) {
    if (transactions.length === 1) {
        return formatFxTooltip(transactions[0]);
    }

    let converted = [];
    for (let t of transactions) {
        if (t.isConverted()) {
            converted.push(t);
        }
    }
    if (converted.length === 0) {
        return null;
    }

    let currencies = [];
    let currencySet = new Set();
    let sources = new Set();
    let quoteKeys = new Set();
    for (let t of converted) {
        let quote = t.getFxQuote();
        let currency = t.getNativeCurrency();
        if (!currencySet.has(currency)) {
            currencySet.add(currency);
            currencies.push(currency);
        }
        sources.add(quote.source);
        quoteKeys.add(quote.from + '>' + quote.to + ':' + quote.rate + ':' + (quote.period ? quote.period : '') + ':' + quote.source);
    }

    let currencyList = currencies.join(', ');
    if (quoteKeys.size === 1) {
        let quote = converted[0].getFxQuote();
        let rate = Number(quote.rate).toLocaleString('cs', {
            maximumFractionDigits: 6
        });
        let source = quote.period ? (quote.source + ' ' + quote.period) : quote.source;
        return 'Includes amounts converted from ' + currencyList + ' × ' + rate + ' (' + source + ')';
    }

    let source = (sources.size === 1) ? sources.values().next().value : null;
    if (source) {
        return 'Includes amounts converted from ' + currencyList + ' (' + source + ')';
    }
    return 'Includes amounts converted from ' + currencyList;
}

export function createFxValue(val, transactions) {
    return createValue(val, formatFxAggregateTooltip(transactions));
}

export function createFilterLabel(f) {
    // note: color is checked & in hex format
    let attributes = {
        class: 'badge badge-info'
    };
    if (f.getColor() != null) {
        attributes.style = `background-color: ${f.getColor()};`;
    }
    return DomBuilder.span(f.getName(), attributes);
}
